import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  badge?: ReactNode;
  columnTitle: string;
  infoTip: ReactNode;
  showAiIcon?: boolean;
}

export const ColumnHeaderInfoTip = ({ columnTitle, infoTip, showAiIcon = false, badge }: Props) => (
  <div css={styles.columnHeader}>
    {badge}
    {showAiIcon && <Icon name='aiassistant-small' />}
    <Text as='span' size='medium' className='title'>
      {columnTitle}
    </Text>
    {infoTip}
  </div>
);

const styles = {
  columnHeader: css`
    align-items: center;
    display: flex;
    gap: ${theme.spacing(0.5)};

    .title {
      color: ${theme.colors.neutral40};
    }
  `,
};
